import Splide from "@splidejs/splide";
const sp = new Splide("#supporters_splide", {
    type: "loop",
    rewind: true,
    perPage: 5,
    perMove: 1,
    speed: 600,
    pagination: false,
    arrows: false,
    direction: "rtl",
    autoplay: true,
    interval: 4000,
    pauseOnHover: false,
    pauseOnFocus: false,
});
$(() => {
    sp.mount();
    sp.Components.Autoplay.play();
});
